module.exports = __webpack_public_path__ + "img/IFC-alt.fd67fcdb.svg";